













import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class BindDatasourceButton extends Vue {
  @Prop() disabled!: boolean;

  get tooltipText() {
    return 'Vincular configuração de dados ao Item';
  }

  click() {
    this.$emit('click');
  }
}
